class SignInMethodType {
    static GOOGLE = "GOOGLE";
    static EMAIL_PASSWORD = "EMAIL_PASSWORD";

}

export default SignInMethodType;